import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval>;
const notify = () => listeners.forEach((listener) => listener());
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  if (listeners.size === 1) {
    timer = setInterval(notify, 60_000);
    document.addEventListener("visibilitychange", notify);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", notify);
    }
  };
};
let now = Date.now();
// The time moves on once a minute, so readers render at most once a minute.
const snapshot = () => {
  const current = Date.now();
  if (Math.floor(current / 60_000) !== Math.floor(now / 60_000)) now = current;
  return now;
};
export const useNow = () => useSyncExternalStore(subscribe, snapshot, snapshot);
